export default "__VITE_ASSET__DZjzkLYC__"